import { forwardRef } from 'react';
import { TextField as MuiTextField, TextFieldProps } from '@mui/material';
import { FormLabelStyled } from './styled';

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  ({ label, ...props }, ref) => {
    return (
      <>
        {label && <FormLabelStyled>{label}</FormLabelStyled>}
        <MuiTextField variant="outlined" {...props} ref={ref} />
      </>
    );
  },
);
